import { render, staticRenderFns } from "./RubricSalInvoiceList.vue?vue&type=template&id=7567cbbb&scoped=true&"
import script from "./RubricSalInvoiceList.vue?vue&type=script&lang=js&"
export * from "./RubricSalInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./RubricSalInvoiceList.vue?vue&type=style&index=0&id=7567cbbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567cbbb",
  null
  
)

export default component.exports